export const ICON_MAP = {
  DEPENDENTE: 'edit',
  TITULAR: 'unlock',
}

export const BUTTON_TEXT_MAP = {
  DEPENDENTE: 'Atualizar conta',
  TITULAR: 'Ativar conta',
}

export const INTERACTION_TEXT_MAP = {
  DEPENDENTE: 'update_data_click',
  TITULAR: 'activate_account_click',
}
